import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  chipsWrapper: {
    maxWidth: '60%',
    textAlign: 'right',
  },
  wrapper: {
    maxWidth: ({ multiple, fullWidth }) =>
      fullWidth ? '100%' : multiple ? 500 : 305,
  },
  dropdownWrapper: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));
